
const Nav = {
    state: {
        navName: ""
    },

    mutations: {
        SET_NAV_NAME: (state, status) => {
            state.navName = status
        },
    },

    actions: {

    }
}

export default Nav
